import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, } from 'react';
import theme from '../../styles/theme';
import { StickyContainer } from '../StickyContainer';
import { DrawerContext } from './DrawerContext';
const containerStyles = css `
  background-color: ${theme.colors.gray100};
  padding-bottom: ${theme.spacing.x4};
  padding-left: ${theme.spacing.x4};
  padding-right: ${theme.spacing.x4};
  padding-top: ${theme.spacing.x4};
  width: 100%;
`;
const DrawerFooter = ({ children, }) => {
    const { drawerContentRef, } = useContext(DrawerContext);
    return (_jsx(StickyContainer, Object.assign({ containerRef: drawerContentRef, position: "bottomOfFixedContainer" }, { children: _jsx("div", Object.assign({ css: containerStyles }, { children: children })) })));
};
const MemoizedDrawerFooter = memo(DrawerFooter);
export { MemoizedDrawerFooter as DrawerFooter };
// MC-1068 Temporary hack for Storybook.
export default DrawerFooter;
